'use strict';

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _right_arrow = require('./right_arrow.svg');

var _right_arrow2 = _interopRequireDefault(_right_arrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Arrow(props) {
    var arrowClasses = (0, _classnames2['default'])(_defineProperty({
        'arrow-button': true
    }, 'arrow-button-' + props.direction, true));
    var lineClasses = (0, _classnames2['default'])(_defineProperty({
        'arrow-line': true
    }, 'arrow-line-' + props.direction, true));
    return _react2['default'].createElement(
        'div',
        { className: 'm-pricing-arrow', 'data-test-id': 'arrow-button' },
        _react2['default'].createElement('div', { className: lineClasses }),
        _react2['default'].createElement('img', { src: _right_arrow2['default'], className: arrowClasses, onClick: props.handleClick })
    );
}

module.exports = Arrow;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/arrow/index.jsx
 ** module id = 1081
 ** module chunks = 0
 **/